<cx-org-sub-list>
  <a actions class="link" routerLink="assign">
    {{ 'organization.assign' | cxTranslate }}
  </a>
</cx-org-sub-list>
